// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"d013d45b","787":"aadca95f"}[chunkId] + ".chunk.js";
};